import React from 'react';
import { object, shape, arrayOf, string, node, bool } from 'prop-types';
import classNames from 'classnames';
import { useSweLang } from '../Helpers';

const BreadCrumb = (props) => {
  if (!props.Breadcrumbs) return null;

  const componentClasses = classNames({
    'c-breadcrumb': true,
    ...props.Modifiers,
  });

  return (
    <nav
      aria-label={props.Name}
      aria-describedby="breadcrumb-label"
      className={componentClasses}
      lang={useSweLang(props.Language)}
    >
      <span id="breadcrumb-label" className="c-breadcrumb__label">
        {props.Label}
      </span>
      <ol>
        {props.Breadcrumbs.map((breadcrumb, index) => {
          return (
            <li key={`breadcrumb${index}`} className="c-breadcrumb__item">
              {!breadcrumb.CurrentPage ? (
                <a href={breadcrumb.Url}>{breadcrumb.Text}</a>
              ) : (
                <a aria-current="page" href={breadcrumb.Url}>
                  {breadcrumb.Text}
                </a>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

BreadCrumb.propTypes = {
  Breadcrumbs: arrayOf(
    shape({
      /** Breadcrumb text */
      Text: node.isRequired,
      /** Should item be rendered as a link */
      HasLink: bool,
      /** Link - required if HasLink is true */
      Url: string,
    })
  ),
  /** First item in the list */
  Label: string,
  /** Classnames compatible object */
  Modifiers: object,
  /**Language for screen reader purpose */
  Language: string,
};

export default BreadCrumb;
